import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';

import {
  EntityDto,
  EntityValidationResponse,
  EntityValidatorDto,
} from '../models';
import { DOCUMENT_CONTROL_API_TOKEN } from '../tokens';

@Injectable({
  providedIn: 'root',
})
export class ValidatorsService {
  public url: string;

  constructor(
    @Inject(DOCUMENT_CONTROL_API_TOKEN) private apiUrl: string,
    private http: HttpClient,
  ) {
    this.url = `${this.apiUrl}/validators`;
  }

  public getValidators({ entityId, entityType = 'list' }: EntityDto) {
    const url = this.getValidatorsUrl(entityType, entityId);
    return this.http
      .get<EntityValidationResponse>(url)
      .pipe(catchError((err) => throwError(() => new Error(err))));
  }

  public patchValidators({
    entityId,
    entityType = 'list',
    validators,
  }: EntityValidatorDto) {
    const url = this.getValidatorsUrl(entityType, entityId);
    return this.http.patch<void>(url, validators).pipe(
      mergeMap(() => this.getValidators({ entityId, entityType })),
      catchError((err) => throwError(() => new Error(err))),
    );
  }

  private getValidatorsUrl(entityType: string, entityId?: string) {
    return entityId
      ? `${this.url}/${entityType}/${entityId}`
      : `${this.url}/${entityType}`;
  }
}
